var module = angular.module('octopusApp.master');

module.directive('gettingStarted', function ($rootScope, octopusPermissionSet) {
    return {
        templateUrl: 'areas/master/getting-started/views/getting_started.html',
        restrict: 'E',
        replace: true,
        scope: {},
        controllerAs: 'vm',
        bindToController: true,
        link: function (scope, element, attrs, controller) {
            var hasProjects = false;
            var stateChangeDetach = function () { };

            element.hide();

            scope.dismiss = function () {
                remove();
            };

            function remove() {
                $('#scrollSpacer').css('padding-top', '0');
                element.remove();
                scope.$destroy();
            }

            function toggle() {
                if (scope.canDismiss === true) {
                    remove();
                    return;
                }

                if (scope.$root.pageTitle !== 'Dashboard') {
                    element.show();
                    return;
                }

                if (hasProjects) {
                    element.show();
                } else {
                    element.hide();
                }
            }

            function refresh(tasksStatus) {
                if (tasksStatus.tasks.Deploy.DeployedRelease.IsComplete) {
                    scope.canDismiss = true;
                    return;
                }

                hasProjects = tasksStatus.projects.length > 0;
                toggle();
            }

            octopusPermissionSet.isAuthorized({
                permission: 'AdministerSystem'
            }).then(function (result) {
                if (!result) {
                    remove();
                    return;
                }

                controller.gettingStartedStatusFactory.promise.then(function (status) {
                    scope.$on('$destroy', function () {
                        stateChangeDetach();
                    });

                    if (status.tasks.Deploy.DeployedRelease.IsComplete) {
                        remove();
                        return;
                    }

                    stateChangeDetach = $rootScope.$on('$stateChangeSuccess', toggle);

                    refresh(status);
                    controller.gettingStartedStatusFactory.subscribe(scope, refresh);
                });
            });
        },
        controller: function ($scope, $uibModal, $localStorage, busy, gettingStartedStatusFactory, $location) {
            var vm = this;
            vm.next = '';
            vm.expand = isBarExpanded();
            vm.dropup = true;
            var isLoading = vm.isLoading = busy.create();

            fixMargin();

            vm.toggle = function () {
                vm.expand = $localStorage.gettingStartedProgressBarExpanded = !vm.expand;
                fixMargin();
            };

            vm.toggleDetail = function () {
                $uibModal.open({
                    backdrop: true,
                    keyboard: true,
                    templateUrl: 'areas/master/getting-started/views/getting_started_dialog.html',
                    controller: 'GettingStartedDialogController',
                    size: 'xlg'
                });
            };

            vm.imageOctopus = require('../../../../img/getting-started/Octopus.svg');
            vm.imageEnvironments = require('../../../../img/getting-started/Environments.svg');
            vm.imagePackage = require('../../../../img/getting-started/Package.svg');
            vm.imageProject = require('../../../../img/getting-started/Project.svg');
            vm.imageDeploy = require('../../../../img/getting-started/Deploy.svg');

            vm.gettingStartedStatusFactory = gettingStartedStatusFactory;

            function isBarExpanded() {
                if (typeof $localStorage.gettingStartedProgressBarExpanded !== 'undefined') {
                    return $localStorage.gettingStartedProgressBarExpanded;
                }

                return true;
            }

            function fixMargin() {
                if (vm.expand === true) {
                    $('#scrollSpacer').css('padding-top', '124px');
                } else {
                    $('#scrollSpacer').css('padding-top', '20px');
                }
            }

            function refresh(tasksStatus) {

                vm.isEnvironmentsPage = $location.path().endsWith('/environments') || $location.path().endsWith('/environments/');

                vm.tasks = tasksStatus.tasks;
                vm.next = tasksStatus.next;
                vm.projects = tasksStatus.projects;
                vm.releases = tasksStatus.releases;
            }
            
            isLoading.promise(
                octopusPermissionSet.isAuthorized({
                    permission: 'AdministerSystem'
                }).then(function (result) {
                    if (!result) {
                        return;
                    }

                    return gettingStartedStatusFactory.promise.then(function (status) {
                        if (status.tasks.Deploy.IsComplete) {
                            return;
                        }

                        refresh(status);
                        gettingStartedStatusFactory.subscribe($scope, refresh);
                    });
                }));
        }
    };
});

module.controller('GettingStartedDialogController', function ($scope, $uibModalInstance) {
    $scope.close = function () {
        $uibModalInstance.close();
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/master/getting-started/directives/getting_started.js
// module id = 8978395433632457
// module chunks = 1